import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';
interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  max: number;
  color: string;
  size: number;
}
const COLORS = ['#E3B23C', '#1E7F6E', '#C2413B', '#F2F6FA', '#4C8FB8'];
export function Fireworks() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;
    let width = 0;
    let height = 0;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener('resize', resize);
    let particles: Particle[] = [];
    let nextBurst = 0;
    let frame = 0;
    let last = performance.now();
    const burst = () => {
      const cx = width * (0.15 + Math.random() * 0.7);
      const cy = height * (0.12 + Math.random() * 0.45);
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      const count = 36 + Math.floor(Math.random() * 22);
      for (let i = 0; i < count; i++) {
        const angle = Math.PI * 2 * i / count + Math.random() * 0.16;
        const speed = 55 + Math.random() * 135;
        const max = 900 + Math.random() * 700;
        particles.push({
          x: cx,
          y: cy,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 0,
          max,
          color: Math.random() < 0.2 ? '#FFFFFF' : color,
          size: 1.4 + Math.random() * 1.8
        });
      }
    };
    const tick = (now: number) => {
      const dt = Math.min(48, now - last);
      last = now;
      ctx.fillStyle = 'rgba(10, 14, 19, 0.24)';
      ctx.fillRect(0, 0, width, height);
      if (now > nextBurst && particles.length < 900) {
        burst();
        nextBurst = now + 700 + Math.random() * 900;
      }
      const seconds = dt / 1000;
      particles = particles.filter(p => {
        p.life += dt;
        if (p.life > p.max) return false;
        p.vy += 42 * seconds;
        p.vx *= 0.985;
        p.vy *= 0.985;
        p.x += p.vx * seconds;
        p.y += p.vy * seconds;
        const alpha = Math.max(0, 1 - p.life / p.max);
        ctx.globalAlpha = alpha * alpha;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        return true;
      });
      ctx.globalAlpha = 1;
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', resize);
    };
  }, [reduced]);
  if (reduced) return null;
  return <canvas ref={canvasRef} aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full" data-id="element-213" data-mp="30vyi2lgay0cs" />;
}